module.exports = __webpack_public_path__ + "static/media/claraglhea.2f0983fb.png";